export const bih = [
        {
            category: 'Cijene voća',
            text: 'Cijene voća u Bosni i Hercegovini',
            config: 'bihFruit',
            subcategories:[
            {
                name: 'Jabuka',
                text: 'Cijene jabuke na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Breskva',
                text: 'Cijene breskve na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Kajsija',
                text: 'Cijene kajsije na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Trešnja',
                text: 'Cijene trešnje na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Jagode',
                text: 'Cijene jagode na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Kivi',
                text: 'Cijene kivija na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Šljive suve',
                text: 'Cijene suve šljive na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Banana',
                text: 'Cijene banane na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Grožđe',
                text: 'Cijene grožđa na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Kruške',
                text: 'Cijene kruške na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Narandže',
                text: 'Cijene narandže na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Šljive',
                text: 'Cijene šljive na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Suve smokve',
                text: 'Cijene suve smokve na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Lubenice',
                text: 'Cijene lubenice na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Dinja',
                text: 'Cijene dinje na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Kesten',
                text: 'Cijene kestena na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Mandarine',
                text: 'Cijene mandarine na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Limun',
                text: 'Cijene limuna na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Nar',
                text: 'Cijene nara na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Očišćeni orasi',
                text: 'Cijene očišćenih oraha na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Ananas',
                text: 'Cijene ananasa na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Avokado',
                text: 'Cijene avokada na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Grejp',
                text: 'Cijene grejpa na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Nektarina',
                text: 'Cijene nektarine na pijacama u Bosni i Hercegovini'
            }
        ]
        },
        {
            category: 'Cijene povrća',
            text: 'Cijene povrća u Bosni i Hercegovini',
            config: 'bihVege',
            subcategories:[
            {
                name: 'Kupus',
                text: 'Cijene mladog kupusa na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Mrkva',
                text: 'Cijene mrkve na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Paradajz',
                text: 'Cijene paradajza na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Paprika',
                text: 'Cijene paprike na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Bijeli luk',
                text: 'Cijene bijelog luka na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Pasulj',
                text: 'Cijene pasulja na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Blitva',
                text: 'Cijene blitve na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Krastavac',
                text: 'Cijene krastavca na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Peršun',
                text: 'Cijene peršuna na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Tikvice',
                text: 'Cijene tikvica na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Mahune',
                text: 'Cijene mahune na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Crni luk',
                text: 'Cijene crnog luka na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Celer',
                text: 'Cijene celera na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Krompir',
                text: 'Cijene krompira na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Boranija',
                text: 'Cijene boranije na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Zelena salata',
                text: 'Cijene zelene salate na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Cvekla',
                text: 'Cijene cvekle na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Pečenjci',
                text: 'Cijene pečenjci na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Špinat',
                text: 'Cijene špinata na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Karfiol',
                text: 'Cijene karfiola na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Patlidžan',
                text: 'Cijene patlidžana na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Grašak',
                text: 'Cijene graška na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Rotkva',
                text: 'Cijene rotkve na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Brokoli',
                text: 'Cijene brokolija na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Čeri paradajz',
                text: 'Cijene čeri paradajza na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Feferona',
                text: 'Cijene feferone na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Kelj',
                text: 'Cijene kelja na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Kupus crveni',
                text: 'Cijene crvenog kupusa na pijacama u Bosni i Hercegovini'
            }
        ]
        },
        {
            category: 'Cijene stoke',
            text: 'Cijene stoke na pijacama u Bosni i Hercegovini',
            config: 'bihCattle',
            subcategories:[
            {
                name: 'Bikovi',
                text: 'Cijene bikova na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Junice',
                text: 'Cijene junica na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Krave',
                text: 'Cijene krava na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Telad (muška)',
                text: 'Cijene muške teladi na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Telad (ženska)',
                text: 'Cijene ženske teladi na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Svinje u klasi',
                text: 'Cijene svinja u klasi na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Svinje van klase',
                text: 'Cijene svinja van klase na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Krmače',
                text: 'Cijene krmača na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Prasad',
                text: 'Cijene prasadi na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Jagnjad',
                text: 'Cijene jagnjadi na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Jarad',
                text: 'Cijene jaradi na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Ovce',
                text: 'Cijene ovaca na pijacama u Bosni i Hercegovini'
            },
            {
                name: 'Ovnovi',
                text: 'Cijene ovnova na pijacama u Bosni i Hercegovini'
            }
        ]
        }
    ]
